import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendWelcomeTextSmsToCaller = async ({ callerId, message }: { callerId: string; message: string }) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      message,
    },
    mutation: graphql(`
      mutation SendWelcomeTextSmsToCaller($callerId: String!, $message: String!) {
        sendWelcomeTextSmsToCaller(callerId: $callerId, message: $message) {
          success
        }
      }
    `),
  });

  return response.data?.sendWelcomeTextSmsToCaller?.success ?? false;
};
